import { render, staticRenderFns } from "./EventNoteForm.vue?vue&type=template&id=c0d7782e&"
import script from "./EventNoteForm.vue?vue&type=script&lang=js&"
export * from "./EventNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports